var Error = {
    errorUnknown: "Ocurrió un error desconocido.",
    error401: 'Su sesión ha caducado o ud no tiene privilegios para realizar esta operación. Por favor, inicie sesión nuevamente.'
}
export {Error};
